import { useState } from 'react';

import { useIntl } from 'react-intl';

import { TDeserialisedPerson } from '../../../modals/idCheckVerificationModal/IdCheckVerificationModal.types';

type PhoneOption = TDeserialisedPerson['phones'][number];

interface SelectPhoneNumberFieldProps {
    name: string;
    options: TDeserialisedPerson['phones'];
    disabled?: boolean;
    value?: string;
    onChange?: (value: string) => void;
    addNewNumber: () => void;
}

export const SelectPhoneNumberField = ({
    name,
    options,
    disabled = false,
    value,
    onChange,
    addNewNumber
}: SelectPhoneNumberFieldProps) => {
    const intl = useIntl();
    const [selectedValue, setSelectedValue] = useState<string>(value || '');

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value;

        if (newValue === 'ADD_NEW') {
            addNewNumber();
            return;
        }

        setSelectedValue(newValue);
        onChange?.(newValue);
    };

    const formatPhoneLabel = (phone: PhoneOption): string => {
        if (phone.label) {
            return phone.label;
        }
        if (phone.number) {
            return phone.number;
        }
        if (phone.value) {
            return phone.value;
        }
        return 'Unknown number';
    };

    const getPhoneValue = (phone: PhoneOption): string => {
        if (typeof phone.value === 'string') return phone.value;
        if (typeof phone.number === 'string') return phone.number;
        if (typeof phone.uid === 'string') return phone.uid;
        return '';
    };

    return (
        <select
            id={name}
            name={name}
            value={selectedValue}
            onChange={handleChange}
            disabled={disabled}
            className="fs-exclude col-span-2 rounded-m border border-structure-80 px-m py-s"
        >
            <option value="" disabled>
                {intl.formatMessage({
                    id: '_.credit_card.onboarding.id_check_verification.selectPlaceholder',
                    defaultMessage: 'Select number'
                })}
            </option>
            {options
                .filter((phone) => phone.type !== 'ADD_NEW')
                .map((phone, index) => (
                    <option
                        key={phone.uid || `phone-${index}`}
                        value={getPhoneValue(phone)}
                    >
                        {formatPhoneLabel(phone)}
                    </option>
                ))}
            <option value="ADD_NEW">
                {intl.formatMessage({
                    id: '_.credit_card.onboarding.id_check_verification.add_number',
                    defaultMessage: 'Add a number'
                })}
            </option>
        </select>
    );
};
